import React from 'react';
import PropTypes from 'prop-types';
import Svg from './Svg';

const arrowType = 'arrow';
class ArrowSvg extends Svg {
	constructor(props) {
		super(props);
	}

	getPlainSVG(xrotation, color, opacity) {
		let rotation = "rotate(" + xrotation + " 256 256)";
		return (
			<svg id={arrowType} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 512 512">
				<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id="Group" transform={rotation} stroke={color} opacity={opacity}>
						<circle id="Oval-Copy" strokeWidth="30" cx="256" cy="256" r="230" ></circle>
						<polygon id="Fill-1-Copy" strokeWidth="16" fill={color} fillRule="nonzero"
							transform="translate(256, 212) rotate(-90.000000) translate(-256, -212) "
							points="170.544 73 159 84.7577648 283.895556 212.016352 159 339.242236 170.544 351 307 212.016352">
						</polygon>
					</g>
				</g>
			</svg>
		);
	}

}

ArrowSvg.propTypes = {
	primaryColor: PropTypes.string.isRequired,
	rotation: PropTypes.number.isRequired
};

export default ArrowSvg;
